var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"kefu",on:{"click":function($event){_vm.show = true}}}),(_vm.show)?_c('div',{staticClass:"total"},[_c('div',{staticClass:"common2"},[_c('contact',{attrs:{"showImg":false}},[_c('div',{staticClass:"close",on:{"click":function($event){_vm.show = false}}})])],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }